import { z } from 'zod';

export const AppPlatform = z.enum(['microsite', 'veeva']);
export type AppPlatform = z.infer<typeof AppPlatform>;